/*
 * Copyright 2026 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 */
package ai

import kotlinx.serialization.Serializable

/**
 * The Wiz 3R three-section output: Reveal · Reason · Realize.
 *
 * - **Reveal**: surface facts the user couldn't easily see (patterns,
 *   contribution room, where money goes).
 * - **Reason**: apply Canadian tax rules and math; show the framework and
 *   trade-offs.
 * - **Realize**: the user achieves goals through their own decisions; the
 *   product never crosses into "we recommend X" (regulatory line — CSA, CIRO,
 *   provincial securities commissions).
 *
 * The text is generated by the LLM (Phase 2). The rules engine supplies the
 * numbers via tool calls; the LLM only wraps them in prose.
 */
@Serializable
data class ReasonedNarrative(
    val reveal: String,
    val reason: String,
    val realize: String,
)
